import { computed, makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestorePromptRubricAIEvent,
} from '../firestore/PromptRubricAIEvent/schema'
import type { FirebaseRepository } from './FirebaseRepository'
import { DateTime } from 'luxon'

export class PromptRubricAIEvent extends ObservableModelWithDecorators<FirestorePromptRubricAIEvent> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestorePromptRubricAIEvent>
  ) {
    super(repository, doc)

    makeObservable(this)
  }

  @computed
  /** return run duration as luxon duration obj, if not ended returns duration 0 */
  get ranFor() {
    const { startedAt, endedAt } = this.doc.data

    // no start time, return 0 dur
    if (!startedAt) return DateTime.now().diffNow()

    const started = DateTime.fromJSDate(startedAt)

    // no end time, return duration from start to now
    if (!endedAt) return DateTime.now().diff(started)

    const ended = DateTime.fromJSDate(endedAt)

    // return duration from start to end
    return ended.diff(started)
  }
}
